import React from "react";
import {CurrencyAbbreviation} from "./CurrencyClasses";

export const CurrencyAbbreviationContext = React.createContext<CurrencyAbbreviation | undefined>(undefined);
